// extracted by mini-css-extract-plugin
export var sbShowMain = "industriesHero-module--sb-show-main--1j37q";
export var industriesHero = "industriesHero-module--industriesHero--2GzW6";
export var icon = "industriesHero-module--icon--3nXV7";